import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'bd-user-cookie-reset-link',
  template: `<a href="#CCM.openWidget">Cookie-Einstellungen</a>`,
  styles: [
    `
      a {
        text-decoration: none;
        color: inherit;
        cursor: pointer;
      }

      a:hover {
        color: var(--p-primary-color);
        text-decoration: underline;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BdUserConsentCookieResetLinkComponent {}
